/* eslint-disable @typescript-eslint/no-non-null-assertion */

export const USED_AS_SPA = "false" === 'true';
export const SENTRY_DSN = "https://1c4b286a279e233253dbfc9109634727@o61655.ingest.sentry.io/4506733891682304" || '';
const SPLIT_IO_API_KEY_STAGING = "n33vr9vfs09671pc90pgi7kvj8q7vvvfvjvd";
const SPLIT_IO_API_KEY_PRODUCTION = "9a44abjpf5r66aq6r9o6426v9n2tg9ko9tah";

// eslint-disable-next-line consistent-return
const config = environment => {
  // eslint-disable-next-line default-case
  switch (environment) {
    case 'TEST':
    case 'LOCAL':
    case 'DEVELOPMENT':
      return {
        AI_ASSISTANT_MODEL: 'learn-assistant-conversation',
        AI_MODEL: 'learn-conversation-test',
        SPLIT_IO_API_KEY: 'localhost',
        urls: {
          AI_API: 'https://ai-api.datacamp-staging.com',
          CAMPUS_API: 'https://campus-api.datacamp-staging.com',
          GROUP_HUB_API: 'https://www.datacamp-staging.com/groups/graphql',
          MAIN_APP: 'https://www.datacamp-staging.com',
          TEACH_APP: 'https://teach-api.datacamp-staging.com/teach-app'
        }
      };
    case 'STAGING':
      return {
        AI_ASSISTANT_MODEL: 'learn-assistant-conversation',
        AI_MODEL: 'learn-conversation-staging',
        SPLIT_IO_API_KEY: SPLIT_IO_API_KEY_STAGING,
        urls: {
          AI_API: 'https://ai-api.datacamp-staging.com',
          CAMPUS_API: 'https://campus-api.datacamp-staging.com',
          GROUP_HUB_API: 'https://www.datacamp-staging.com/groups/graphql',
          MAIN_APP: 'https://www.datacamp-staging.com',
          TEACH_APP: 'https://teach-api.datacamp-staging.com/teach-app'
        }
      };
    case 'PRODUCTION':
      return {
        AI_ASSISTANT_MODEL: 'learn-assistant-conversation',
        AI_MODEL: 'learn-conversation-prod',
        SPLIT_IO_API_KEY: SPLIT_IO_API_KEY_PRODUCTION,
        urls: {
          AI_API: 'https://ai-api.datacamp.com',
          CAMPUS_API: 'https://campus-api.datacamp.com',
          GROUP_HUB_API: 'https://www.datacamp.com/groups/graphql',
          MAIN_APP: 'https://www.datacamp.com',
          TEACH_APP: 'https://teach-api.datacamp.com/teach-app'
        }
      };
  }
};
export default config;